import React from 'react';

import { QuestionMarkSvg } from '../../common/svg';

import '../../../styles/shop/print-frames-control.scss';

const PrintFramesControl = props => {
  return (
    <>
      <span className="product-view__meta-label">
        Frame Type{' '}
        <button
          className="icon-link"
          onClick={() => props.showModalWithContent(
            <>
              <p className="header">
                Frame Type
              </p>
              <p className="body-text">
                All frames are custom made to order.
              </p>
              <ul className="body-text">
                <li>Solid wood with a 3/4″ face (and 1″ depth for US orders, 3/4“ elsewhere).</li>
                <li>2” acid-free 4-ply natural white mat with beveled edges</li>
                <li>Shatterproof, high quality UV-shielding acrylic glazing</li>
                <li>Archival acid-free foam core backing</li>
              </ul>
              <p className="body-text">
                Why acrylic instead of glass? Although more expensive than glass, like most art-sellers and galleries we’ve chosen acrylic for its superior UV protection, and because it is also lighter and much less breakable — not only does this ensure it gets to you safely, but also handy for when you might want to move house in the future!
              </p>
            </>
          )}>
            { QuestionMarkSvg }
          </button>
      </span>
      <div className="print-frames__container">
        <button
          className={`print-frames__option ${(props.frame === 'None') ? 'selected' : ''}`}
          onClick={() => props.onChange('None')}
        >
          <div className="print-frames__label">None</div>
          <div className="print-frames__detail">Print Only</div>
        </button>
        <button
          className={`print-frames__option ${(props.frame === 'Black') ? 'selected' : ''}`}
          onClick={() => props.onChange('Black')}
        >
          <img src="/images/shop/black-corner.jpg" alt="black frame demonstration" />
          <div className="print-frames__label">Black</div>
        </button>
        <button
          className={`print-frames__option ${(props.frame === 'White') ? 'selected' : ''}`}
          onClick={() => props.onChange('White')}
        >
          <img src="/images/shop/white-corner.jpg" alt="white frame demonstration" />
          <div className="print-frames__label">White</div>
        </button>
        <button
          className={`print-frames__option ${(props.frame === 'Natural') ? 'selected' : ''}`}
          onClick={() => props.onChange('Natural')}
        >
          <img src="/images/shop/natural-corner.jpg" alt="natural frame demonstration" />
          <div className="print-frames__label">Natural</div>
        </button>
        <button
          className={`print-frames__option ${(props.frame === 'Brown') ? 'selected' : ''}`}
          onClick={() => props.onChange('Brown')}
        >
          <img src="/images/shop/brown-corner.jpg" alt="brown frame demonstration" />
          <div className="print-frames__label">Brown</div>
        </button>
      </div>
    </>
  );
}

export default PrintFramesControl;